// 我的类
let mockBaseUrl = 'http://rap2api.taobao.org/app/mock/228718'
export default {
  // 获取代理人基本信息接口
  '/agent/agent/info': mockBaseUrl + '/agent/agent/info',
  // 获取代理人收入信息接口
  '/agent/income/info': mockBaseUrl + '/agent/income/info'
}
